module.exports = __webpack_public_path__ + "static/media/8.ebadc46d.jpg";